import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { daysOptions } from "@data/constants/formConstants"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { TouchableOpacity, View } from "react-native"
import { DatePickerModal, TimePickerModal } from "react-native-paper-dates"
import SelectDayModal from "./SelectDayModal"

const DayTimeItem = ({
    onPress = () => {},
    label,
    disabled = false,
    compact = false,
}) => (
    <TouchableOpacity activeOpacity={0.8} onPress={onPress} disabled={disabled}>
        <View
            style={{
                flexDirection: "row",
                width: compact ? 100 : 140,
                backgroundColor: theme.colors.greyBg,
                borderRadius: compact ? 8 : 15,
                borderColor: theme.colors.light,
                borderWidth: 1,
                paddingVertical: compact ? 4 : 6,
                paddingHorizontal: compact ? 8 : 12,
                flexWrap: "wrap",
                marginRight: compact ? 4 : 10,
            }}
        >
            <TextM
                style={{
                    borderColor: theme.colors.primary,
                    fontSize: compact ? 11 : 14,
                    marginVertical: compact ? 2 : 7,
                }}
                wrap
            >
                {label ?? " "}
            </TextM>
        </View>
    </TouchableOpacity>
)

const DateTimePicker = (props) => {
    const {
        style,
        control,
        setFormValues,
        field,
        type,
        range = undefined,
        compact = false,
    } = props
    const [isTimePickerVisible, setTimePickerVisibility] = useState(false)
    const [isDatePickerVisible, setDatePickerVisibility] = useState(false)

    const [date, setDate] = useState(
        field?.value
            ? type === "day-time"
                ? new Date(field?.value?.day + " " + field?.value?.time)
                : new Date(field?.value)
            : null
    )
    const [dateLabel, setDateLabel] = useState(
        type === "day-time" || type === "time"
            ? null
            : moment(field.value, "DD-MM-YYYY HH:mm").isValid()
            ? moment(field?.value?.split(" ")?.[0]).format("DD-MM-YYYY")
            : "Date"
    )
    const [timeLabel, setTimeLabel] = useState(
        field?.value?.split(" ")?.[1] ?? "Heure"
    )
    const [dayLabel, setDayLabel] = useState(
        daysOptions?.find((d) => d.value === field?.value?.split(" ")?.[0])
            ?.label ?? "Jour"
    )
    const [dayValue, setDayValue] = useState(
        field?.value?.split(" ")?.[0] ?? null
    )

    useEffect(() => {
        if (field?.value) {
            if (type === "day-time") {
                const day = daysOptions?.find(
                    (d) => d.value === field?.value?.split(" ")?.[0]
                )?.label
                setDayLabel(day)
                setDayValue(field?.value?.split(" ")?.[0])
                setTimeLabel(field?.value?.split(" ")?.[1])
            } else if (type === "time") {
                setTimeLabel(field?.value)
            } else if (type === "date-time") {
                const dd = new moment(field?.value?.split(" ")?.[0]).format(
                    "YYYY-MM-DD"
                )
                const dl = new moment(field?.value?.split(" ")?.[0]).format(
                    "DD-MM-YYYY"
                )
                setDate(new Date(dd))
                setDateLabel(dl)
                setTimeLabel(field?.value?.split(" ")?.[1])
            } else {
                const dd = new moment(field?.value?.split(" ")?.[0]).format(
                    "YYYY-MM-DD"
                )
                const dl = new moment(field?.value?.split(" ")?.[0]).format(
                    "DD-MM-YYYY"
                )
                setDate(new Date(dd))
                setDateLabel(dl)
            }
        }
    }, [field.value])

    const showDatePicker = () => {
        setDatePickerVisibility(true)
    }
    const hideDatePicker = () => {
        setDatePickerVisibility(false)
    }
    const showTimePicker = () => {
        setTimePickerVisibility(true)
    }
    const hideTimePicker = () => {
        setTimePickerVisibility(false)
    }
    const [visibleModal, setVisibleModal] = useState(false)
    const handleShowModal = () => {
        setVisibleModal(!visibleModal)
    }

    const onConfirmDay = (day, index, valueDay) => {
        setDayLabel(day)
        setDayValue(valueDay)
        field.onChange(valueDay + " " + timeLabel)
        setFormValues({
            ...control._formValues,
            [field?.name]: valueDay + " " + timeLabel,
        })
    }

    const onConfirmDatePickerModal = (e) => {
        hideDatePicker()
        const dd = new moment(e.date).format("YYYY-MM-DD")
        const dl = new moment(e.date).format("DD-MM-YYYY")
        setDate(new Date(dd))
        setDateLabel(dl)
        field.onChange(type === "date" ? dd : dd + " " + timeLabel)
        setFormValues({
            ...control._formValues,
            [field?.name]: type === "date" ? dd : dd + " " + timeLabel,
        })
    }

    useEffect(() => {
        if (
            field.value &&
            !moment(field.value, "DD-MM-YYYY HH:mm").isValid() &&
            type === "date-time"
        ) {
            setDate(new Date())
        }
    }, [])

    return (
        <>
            <View style={{ flex: 1, alignItems: "center", ...style }}>
                <View style={{ flexDirection: "row", marginTop: 10 }}>
                    {type === "day-time" && (
                        <DayTimeItem
                            onPress={() => handleShowModal()}
                            label={dayLabel}
                            disabled={props.disabled}
                            compact={compact}
                        />
                    )}
                    {(type === "date" || type === "date-time") && (
                        <DayTimeItem
                            onPress={() => showDatePicker()}
                            label={dateLabel}
                            disabled={props.disabled}
                            compact={compact}
                        />
                    )}
                    {(type === "time" ||
                        type === "date-time" ||
                        type === "day-time") && (
                        <DayTimeItem
                            onPress={() => showTimePicker()}
                            label={timeLabel}
                            disabled={props.disabled}
                            compact={compact}
                        />
                    )}
                </View>
            </View>
            {(type === "time" ||
                type === "date-time" ||
                type === "day-time") && (
                <TimePickerModal
                    label={"Sélectionner une heure"}
                    hours={timeLabel?.includes(":") ? parseInt(timeLabel.split(":")[0], 10) : new Date().getHours()}
                    minutes={timeLabel?.includes(":") ? parseInt(timeLabel.split(":")[1], 10) : 0}
                    cancelLabel={"Annuler"}
                    confirmLabel={"Confirmer"}
                    keyboardIcon={"keyboard"}
                    clockIcon={"clock"}
                    locale={"fr"}
                    visible={isTimePickerVisible}
                    onDismiss={hideTimePicker}
                    onConfirm={(e) => {
                        const hours =
                            e.hours?.toString().length > 1
                                ? e.hours
                                : "0" + e.hours
                        const minutes =
                            e.minutes?.toString().length > 1
                                ? e.minutes
                                : "0" + e.minutes
                        const time = hours + ":" + minutes
                        const dd = new moment(date).format("YYYY-MM-DD")

                        setTimeLabel(time)
                        hideTimePicker()
                        field.onChange(
                            type === "time"
                                ? time
                                : type === "day-time"
                                ? dayValue + " " + time
                                : dd + " " + time
                        )
                        setFormValues({
                            ...control._formValues,
                            [field?.name]:
                                type === "time"
                                    ? time
                                    : type === "day-time"
                                    ? dayValue + " " + time
                                    : dd + " " + time,
                        })
                    }}
                />
            )}
            {(type === "date" || type === "date-time") && (
                <DatePickerModal
                    label={"Sélectionner une date"}
                    cancelLabel={"Annuler"}
                    saveLabel={"Confirmer"}
                    closeIcon={"times"}
                    editIcon={"edit"}
                    allowEditing={false}
                    calendarIcon={"calendar"}
                    locale="fr"
                    startWeekOnMonday={true}
                    mode="single"
                    visible={isDatePickerVisible}
                    onDismiss={hideDatePicker}
                    date={date}
                    validRange={range}
                    onConfirm={onConfirmDatePickerModal}
                    onChange={onConfirmDatePickerModal}
                />
            )}
            <SelectDayModal
                control={control}
                handleShowModal={handleShowModal}
                isOpen={visibleModal}
                initialValue={dayValue}
                // fieldName={field?.name}
                onConfirmDay={onConfirmDay}
            />
        </>
    )
}

export default DateTimePicker
